export default __webpack_public_path__ + "static/media/Fahad.106541b4.png";